<template>
	<div style="margin: 10px;">
		<el-card class="box-card">
			<el-row>
				<el-col :span="24">
					<h4 class="title">商品参数信息</h4>
					<el-form ref="form" :model="form" label-width="160px" :rules="rules">
						<!-- <el-form-item label="一级分类" prop="one">
							<el-select  v-model="form.one" placeholder="一级分类" @change="getOne" style="width: 30%;">
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listOne" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="二级分类" size="mini" prop="two"  v-show="twoShow">
							<el-select v-model="form.two" placeholder="二级分类" @change="getTwo($event,'two')" style="width: 30%;">
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listTwo" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="三级分类" size="mini" prop="three" v-show="threeShow">
							<el-select v-model="form.three" placeholder="三级分类">
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listThree" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item label="标题" prop="title">
							<el-input v-model="form.title" style="width: 30%;"></el-input>
						</el-form-item>

						<el-form-item label="状态" prop="resource">
							<el-radio-group v-model="form.resource">
								<el-radio :label="1" value="0">必填</el-radio>
								<el-radio :label="0" value="1">非必填</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item>
							<input  type="button" class="submit" @click="onSubmit('form')" value="提交">
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
	import E from "wangeditor";
	import EditorBar from '../../../components/editor.vue'
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				listOne: [],
				listTwo: [],
				listThree: [],
				form: {
					// one: '',
					// two: '',
					// three: '',
					title: '',
					pic: '',
					detail: '',
					desc: '',
					imagesThumb: '',
					resource:'',
					size:'',
					file:'',
					id:''
				},
				isClear: false,
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					// one: [{
					// 	required: true,
					// 	message: '请选择一级分类',
					// 	trigger: 'change'
					// }],
					// two: [{
					// 	required: true,
					// 	message: '请选择二级分类',
					// 	trigger: 'change'
					// }],
					// three: [{
					// 	required: true,
					// 	message: '请选择三级分类',
					// 	trigger: 'change'
					// }]
				},
				iden: '',
				fileList: [],
				picList:[],
				twoShow:false,
				threeShow:false,
			}
		},
		created() {
			this.iden = this.$route.query.iden
			if (this.iden == 'add') {
				this.form.resource = 0
				return;
			} else {
				this.getData()
			}
			//获取一级分类
		},
		mounted() {

		},
		methods: {
			//如果是编辑的话将数据回显
			getData() {
				var list = this.$route.query.rows
				this.form.title = list.title
				// this.form.one = list.oneCate
				// this.form.two = list.twoCate
				// this.form.three = list.threeCate
				this.form.pic = list.images
				this.form.imagesThumb = list.imagesThumb
				this.form.resource = list.must
				this.form.detail = list.content
				this.form.desc = list.brief
				this.form.id = list.id
				this.form.file = list.download
				this.form.size = list.size
			},
			//获取分类
			getType() {
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/column/one',
					params: {
 
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listOne = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//二级分类
			getOne(event) {
				this.twoShow = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/column/child',
					params: {
 
						id: event
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listTwo = res.data.data
							
						if(this.$route.query.iden == 'update'){
							this.getTwo(this.form.two)
						}
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//三级分类
			getTwo(event,type) {
				if(type != undefined){
					this.form.three = ''
				}
				this.threeShow = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/parameter/column/child',
					params: {
 
						id: event
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.listThree = res.data.data
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
				
			//添加
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this
							obj.$http({
								method: 'post',
								url: 'api/v2/goods/parameter/add',
								data: {
									 cid:this.$route.query.id,
									title: this.form.title,
									must:this.form.resource,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功');
									this.$router.push({
										path:'/home/parameters',
										query:{
											id:this.$route.query.id
										}
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.onUpdate(formName)
				}
			},
			//修改
			onUpdate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this
						obj.$http({
							method: 'post',
							url: 'api/v2/goods/parameter/update',
							data: {
								 cid:this.$route.query.id,
								id:this.form.id,
								title: this.form.title,
								must:this.form.resource,
							},
						}).then((res) => {
							if (res.data.status == 200) {
								this.$message.success('修改成功');
								this.$router.push({
									path:'/home/parameters',
									query:{
										id:this.$route.query.id
									}
								})
							} else {
								this.$message.error(res.data.message);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-form-item__label {
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.3;
	}

	.title {
		display: inline-block;
		padding: 30px 0 30px 0;
	}

	.titleTip {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/commodity/parameterUpdate.vue